import React from 'react';
import { graphql, Link, StaticQuery } from 'gatsby';
import * as styles from './sidebar.module.scss';
import CATEGORIES from '../../../../constants/categories';
import AnimateHeight from 'react-animate-height';
import Angle from '../../../../assets/images/svg/angle.svg';
import { classNames } from '../../../../utils';
import { useLocation } from '@reach/router';


export default class Sidebar extends React.Component {
  state = {
    panels: {},
  };

  toggle( category ) {
    const { panels } = this.state;

    panels[ category ] = panels[ category ] === 0 ? 'auto' : 0;
    this.setState( { panels } );
  }

  renderSections( data ) {
    const { panels } = this.state;
    const { pathname } = useLocation();

    return CATEGORIES.map( ( { category, label } ) => {
      const docs = data.allMdx.edges.filter( doc => doc.node.fields.category === category );

      if ( ! docs.length ) {
        return null;
      }

      const height  = panels[ category ] === 0 ? 0 : 'auto';
      const panelId = `sidebar-panel-${ category }`;
      const isOpen  = height !== 0;

      return (
        <section key={ category } className={ styles.sidebarSection }>
          <h3 className={ styles.sidebarHeading }>
            <button
              aria-expanded={ isOpen }
              aria-controls={ panelId }
              aria-label={ `${ isOpen ? 'Collapse' : 'Open' } ${ category } panel` }
              onClick={ () => this.toggle( category ) }
              className={ height === 0 ? '' : 'is-active' }
            >
              <Angle />
              <span>{ label }</span>
            </button>
          </h3>

          <AnimateHeight
            id={ panelId }
            duration={ 250 }
            height={ height }
          >
            <ul>
              { docs.map( ( { node } ) => (
                <li
                  key={ node.id }
                  className={ classNames(
                    styles.sidebarItem,
                    pathname === node.fields.slug ? styles.sidebarItemActive : ''
                  ) }
                >
                  <Link
                    className={ styles.sidebarLink }
                    activeClassName={ styles.sidebarLinkActive }
                    to={ node.fields.slug }
                  >
                    { node.frontmatter.title }
                  </Link>
                </li>
              ) ) }
            </ul>
          </AnimateHeight>
        </section>
      );
    } );
  }

  render() {
    const { className } = this.props;

    return (
      <aside className={ className }>
        <StaticQuery
          query={ graphql`
            query {
              allMdx(sort: {order: ASC, fields: frontmatter___order}) {
                edges {
                  node {
                    id
                    fields {
                      category
                      slug
                    }
                    frontmatter {
                      title
                    }
                  }
                }
              }
            }
          `}

          render={ this.renderSections.bind( this ) }
        />
      </aside>
    );
  }
}